import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const ConnectedIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 14"
         fill="none"
         {...props}
      >
         <path
            d="M5.39625 0C2.415 0 0 2.34792 0 5.24635C0 8.00625 2.20125 10.2958 5.03625 10.4781L5.34 10.4964C5.835 10.5292 6.26625 10.1646 6.29625 9.68333C6.32625 9.20208 5.955 8.78281 5.45625 8.75365L5.1525 8.73542C3.26625 8.61146 1.8 7.08385 1.8 5.24635C1.8 3.31771 3.40875 1.75 5.39625 1.75L11.4038 1.75C13.3875 1.75 15 3.31406 15 5.24635C15 7.0875 13.5338 8.61146 11.6438 8.73177L11.34 8.75C10.845 8.78281 10.47 9.19844 10.5 9.67969C10.53 10.1609 10.9613 10.5255 11.4563 10.4927L11.76 10.4745C14.595 10.2922 16.7963 8.0026 16.7963 5.24271C16.8 2.34792 14.385 0 11.4038 0L5.39625 0ZM18.6038 14C21.585 14 24 11.6521 24 8.75365C24 5.99375 21.7988 3.70417 18.9638 3.52188L18.66 3.50365C18.165 3.47083 17.7338 3.83542 17.7038 4.32031C17.6738 4.80521 18.045 5.22083 18.54 5.25L18.8438 5.26823C20.7338 5.39219 22.2 6.91615 22.2 8.75365C22.2 10.6823 20.5913 12.25 18.6038 12.25H12.5963C10.6088 12.25 9 10.6859 9 8.75365C9 6.9125 10.4663 5.38854 12.3563 5.26458L12.6225 5.24635C13.1175 5.21354 13.4925 4.79792 13.4588 4.31302C13.425 3.82813 12.9975 3.46719 12.4987 3.5L12.2325 3.51823C9.40125 3.70417 7.2 5.99375 7.2 8.75365C7.2 11.6521 9.615 14 12.5963 14H18.6038Z"
            fill="currentColor"
         />
      </svg>
   )
}

export default ConnectedIcon
